/*import Swal from 'sweetalert2'*/

/*
    Loaded only in the product page
*/

// Shopify resize image
// https://gist.github.com/DanWebb/cce6ab34dd521fcac6ba

window.resizeImage = (src, size, crop = '') => src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
.replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
    if (crop.length) {
        // eslint-disable-next-line no-param-reassign
        crop = `_crop_${crop}`;
    }
    return `_${size}${crop}${match}`;
});

// Handle quantity input fields for GAF Campaign
document.querySelectorAll('[name="quantity"]').forEach((qty) => {
    qty.addEventListener('change', () => {
        const $qtyText = document.querySelector('[data-gaf-campaign-qty-text]')
        if ($qtyText) {
            $qtyText.textContent = `${qty.value} for $${qty.dataset.price / 100 * qty.value}.00`
        }
    })
})


//Updates the PDP price when a bundle 'variant' selected is higher than the base price
function adjustPDPPriceChange() {
  var priceLabel = document.querySelector(".product__price span[data-price]");//main bundle price object


  if (priceLabel !== null) {
    if (priceLabel.classList.contains("pseudo-bundle-price")){
      var selectElement = document.getElementById("variant-selector");
      var selectedAnimPriceData = selectElement.options[selectElement.selectedIndex].dataset.variantPrice;
      var selectedAnimPrice = Number(selectedAnimPriceData.replace('$', ''));

      priceLabel.textContent = "$" + (selectedAnimPrice + Number(priceLabel.dataset.bundlePrice)) + ".00"
    } else {
      var selectedOption = document.getElementById("variant-selector").options[document.getElementById("variant-selector").selectedIndex];

      if ( selectedOption.getAttribute('data-variant-price') != priceLabel.textContent ) { //if the bundle prices are different
        priceLabel.textContent = selectedOption.getAttribute('data-variant-price');

        if ( document.querySelector(".pdp-member-price") !== null) {//if user is member with discount
          var memberPrice = parseFloat(document.querySelector(".product__price span[data-price]").textContent.replace(/[^\d.-]/g, "")) * .75
          document.querySelector(".pdp-member-price").textContent = "$" + memberPrice.toFixed(2)
        }
      }

    }
  }

}

//Updates the PDP form's drop down selector for variants and initiates adjustPDPPriceChange()
function swatchSelectUpdate(e){
  var isButton = e.target.nodeName === 'BUTTON';
  if (!isButton){
    return
  }else{
    const selectedSwatch = document.querySelector(".product__color-swatch.selected");
    var variantSelector = document.getElementById('variant-selector');

    //console.log("variant:", typeof variantSelector.value, "swatch: ", typeof selectedSwatch.value)
    variantSelector.value = selectedSwatch.value;

    // Find the matching option in the select element
    /*
    const options = variantSelector.options;
    for (let i = 0; i < options.length; i++) {
      console.log("option and value: ", options[i].value, selectedSwatch.value)
      if (options[i].value === selectedSwatch.value) {
        console.log("updated value")
        variantSelector.selectedIndex = i; // Set the selected index
        break; // Exit the loop once we find the match
      }
    }
    console.log("past updated loop")*/

    if (selectedSwatch.dataset.pseudoAnimal != true){
      if (selectedSwatch.getAttribute("pd") != "0") {
        document.getElementById('variantName').innerText = selectedSwatch.title + " +" + selectedSwatch.getAttribute("pd")
      } else {
        document.getElementById('variantName').innerText = selectedSwatch.title
      }
    }

    adjustPDPPriceChange();
  }
}

//Prevent Default on ATC button
function preventATCDefault() {
  document.querySelector('form[action="/cart/add"]').addEventListener("submit", function(event) {
    event.preventDefault(); // Prevent the default form submission
  
    document.getElementById("myModal").style.display = "block";
  });
  
  // Close the modal when the close button is clicked
  /*document.getElementById("closeModal").addEventListener("click", function() {
    document.getElementById("myModal").style.display = "none";
  });*/

}

//Focuses and opens Upsell Modal
function upsellModalFocus(){
  const  focusableElements =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const modal = document.querySelector('#upsell-modal');

  jQuery.getJSON('/cart.js', function(cart) {
    document.querySelector('span[data-js-cart-count]').textContent = parseFloat(cart.item_count);
  });

  const firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
  const focusableContent = modal.querySelectorAll(focusableElements);
  const lastFocusableElement = focusableContent[focusableContent.length - 1];


  document.addEventListener('keydown', function(e) {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) { // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        e.preventDefault();
      }
    } else { // if tab key is pressed
      if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }
  });

  firstFocusableElement.focus();
}

//Submits product form when ATC button is pressed on PDP
function submitATCForm(product, tagged, bundle_upsell_metafield){
  if (product.available) { //If product is not sold out
    var contains_upsells = tagged;
    var new_bundle_flag = false;

    if (product.tags.includes('card_include') && !product.tags.includes('card_exclude')) {
      var upsellModal = document.getElementById('upsell-modal__bg');
      var greetingCardTextarea = document.getElementById('greetingCardTextarea');
      var errorText = document.getElementById('greetingCardError');
      var error = false;

      if (!product.tags.includes('card_optional')) {
        if (greetingCardTextarea.value.trim().customTrim() === '' || greetingCardTextarea.value.trim().customTrim() === '.') {
          // The notecard is empty
          // A message that contains only spaces or tabs is also considered empty.
          error = "Don't forget your Personalized Card!";
          errorText.style.display = 'block';
          greetingCardTextarea.classList.add('notecardError');
          if(document.getElementById('greetingCardTextarea').placeholder == "Don’t skip this part! Say something from the heart 💙" && document.querySelector('.suggestion-wrapper').style.display == 'none'){
            document.getElementById('theseIdeas').click();
          }
          document.getElementById('greetingCardTextarea').focus();
        }
      }

      if (greetingCardTextarea.value.length > 400) {
        // Notecard input is longer than 400 characters
        error = "Custom note can't be longer than 400 characters long";
      }

      if (error != false) {
        // Input is not valid
        // Add error to page, and scroll up to the notecard textarea
        errorText.innerHTML = error;
        errorText.style.color = "red";
        
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        /*var offsetTop = greetingCardTextarea.getBoundingClientRect().top;*/
        var offsetTop = document.querySelector('.customization_label').getBoundingClientRect().top;
        window.scrollTo(0, scrollTop + offsetTop - 150);
        return false;
      }
      checkForAddonRecs(greetingCardTextarea);
    }
  }

  if (product.variants.length > 1 && document.querySelector(".pseudo-bundle-info") === null){ //variants but not new bundle
    var varId = document.querySelector('select[name="id"] option:checked').getAttribute('value');
    
  } else if (document.querySelector(".pseudo-bundle-info") !== null) { //new style bundle
    new_bundle_flag = true;
    var bundle_id = document.querySelector(".pseudo-bundle-info").dataset.bundleId;
  } else {
    var varId = product.variants[0].id;
  }
  
  if (product.tags.includes('card_include')) {
    var notecardMsg = document.querySelector('#greetingCardTextarea').value.trim().customTrim();
    if (product.type == "Bundle" && product.variants.length <= 1 && document.querySelector(".pseudo-bundle-info") === null){
      var formData = {
        'items': [{
          'id': varId,
          'quantity': 1,
          'properties':{
            'Personalized Card': notecardMsg,
          }
        }]
      }
    } else if (product.type == "Bundle" && document.querySelector(".pseudo-bundle-info") !== null){
      var chosenAnimal = document.querySelector(".product__color-swatch.selected").dataset.animalHandle;
      var animal_id = document.querySelector('select[name="id"] option:checked').value;
    
      var formData = {
        'items': [
          {
            'id': bundle_id,
            'quantity': 1,
            'properties':{
              '_goes-with-animal': chosenAnimal
            }
          },
          {
            'id': animal_id,
            'quantity': 1,
            'properties':{
              'Personalized Card': notecardMsg
            }
          }

        ]
      }
    } else {
      var formData = {
        'items': [{
          'id': varId,
          'quantity': 1,
          'properties':{
            'Personalized Card': notecardMsg,
          }
        }]
      }
    }
  } else if (product.variants.length <= 1 && (product.type == "GiveAFriend" || product.type == "GiveAFriend Campaign")) {
    document.querySelectorAll('form[action=\'/cart/add\']')[0].submit();
  } else if (product.variants.length > 1 && (product.type == "GiveAFriend" || product.type == "GiveAFriend Campaign")) {
    const quantityText = document.querySelector("[data-gaf-campaign-qty-text]").innerText;
    const quantity = parseInt(quantityText.replace(/(\d+).*/, '$1'), 10);
    var formData = {
      'items': [{
        'id': varId,
        'quantity': quantity
        }]
    }
  } else {
    var formData = {
      'items': [{
        'id': varId,
        'quantity': 1
        }]
    }
  }
  jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
    if(status === "success"){
      //update modal main prod info
      if (new_bundle_flag) {
        var animal_price = document.querySelector(".product__color-swatch.selected").dataset.animalPrice;
        var bundle_price = Number(animal_price) + bundle_upsell_metafield.price;
        
        document.querySelector('.product-details_money').innerText = "$" + (bundle_price).toString();
        document.querySelector('.upsell-product-line__img').src = bundle_upsell_metafield.photo;            
      } else if (product.variants.length > 1 && document.querySelector("section.gaf-template") === null) {//changed upsell info based on variant if bundle 
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id == varId) {
            document.querySelector('.product-details_money').innerText = "$" + (product.variants[i].price/100).toString();
            document.querySelector('.upsell-product-line__img').src = product.variants[i].featured_media.preview_image.src
            break;
          }
        }
      }
      if (contains_upsells){ //has upsells -> show upsell list
        //show the modal
        upsellModal.style.display = 'flex';
        document.body.style.overflowY = 'hidden';
        upsellModalFocus();
      } else { //go to cart
        window.location.href = "/cart";
      }
    }
    },"json")
  
    //document.querySelectorAll('form[action=\'/cart/add\']')[0].submit();
}

//Functions/Listeners to add when DOM is loaded
window.onload = function(){
  //Adds event listeners to swatches to call swatchSelectUpdate when a new swatch is selected
  if (document.querySelector(".product-form__color-swatches") !== null) {
    document.querySelector(".product-form__color-swatches").addEventListener("click", (event) => {swatchSelectUpdate(event)})
  }

  // Handle bundle variant price descrepancies
  /*if (document.querySelector(".product-form__variants .select-wrapper:not(.upsell-prop-input) select#variant-selector") !== null) {
    document.querySelector(".product-form__variants .select-wrapper:not(.upsell-prop-input) select#variant-selector").addEventListener('change', (event) => {
      adjustPDPPriceChange(event);
    });
  }*/
}

/* START add-on recommendations */
function findCategories(text) {
  const flaggedCategories = {
    'moon-back-add-on': ['i love you to', 'moon', 'special'],
    'deluxe-moon-back-bundle': ['i love you to', 'moon', 'special'],
    'thinking-of-you-addon': ['thinking of you', 'missing you', 'miss you', 'cheer', 'proud', 'you got this'],
    'bday-add-on': ['birthday', 'birth', 'bday', 'b-day'],
    'self-care-add-on': ['take care', 'get better', 'hard time', 'relax', 'comfort', 'strong', 'care'],
    'deluxe-self-care-add-on': ['take care', 'get better', 'hard time', 'relax', 'comfort', 'strong', 'care'],
    'you-are-my-sunshine-add-on': ['sun', 'little reminder'],
    'deluxe-sunshine-bundle': ['sun', 'little reminder']
  };
  const matchedCategories = [];

  for (const category in flaggedCategories) {
    const containsFlaggedMsg = flaggedCategories[category].some(keyword => text.includes(keyword));
    
    if (containsFlaggedMsg) {
      matchedCategories.push(category); // Add matched category to the array
    }
  }
  
  return matchedCategories; // Return all matched categories
}

function prependAddonTopOfList(addonHandle) {
  const addon = document.querySelector("li." + addonHandle);
  const upsellList = document.querySelector(".upsell-modal__upsell-list");
  
  if (addon && upsellList) {
    upsellList.prepend(addon);
  }
}

function checkForAddonRecs(msg) {
  const msgText = msg.value.toLowerCase();
  const detectedCategories = findCategories(msgText);
  
  if (detectedCategories.length > 0) {
    detectedCategories.forEach(category => {
      prependAddonTopOfList(category);
    });
  }
}

